import { FormControl } from "@angular/forms";
import { emailRegex } from "./emailValid";
import { phoneRegex } from "./phoneValid";
import { urlRegex } from "./validUrl";

export const contactValid = (control: FormControl) => {
    const value = control.value || "";
    const errors = { contactInvalid: "Please enter valid contact" };
    const validators = [phoneRegex, emailRegex, urlRegex];
    const isInvalid = validators.every(rgx => !rgx.test(value));
    return value === "" ? null : isInvalid ? errors : null;
};
